import BannerBtcDiscountHeader from './banner-bitcoin-discount-header';

export default BannerBtcDiscountHeader;
